import React from 'react'

export default () => (
  <div className="row">
    <div className="col-lg-6">
      <p>
        0.062", ENIG, FR4 Tg180, Green Solder Mask, White <br />
        Silkscreen, 1 oz Cu (Inner and Outer Layers) <br />
        <strong>Cutoff Time (PST)</strong> Noon. The next business day is day 1<br />
        V-score not available
      </p>
    </div>
    <div className="col-lg-6">
      <p className="why-use-standar-prices">
        Standards Specs PCBs usually have
        Better Prices and the Same Quality
      </p>
    </div>
  </div>
)
